import React from "react";
import { Box, Typography } from "@mui/material";
import { animated } from "@react-spring/web";

const StatusOverlays = ({
  showEnvironmentLabel,
  envLabelBottom,
  playerOffset,
  overlayPadding,
  overlayWidth,
  currentEnvironment,
  instructionsVisible,
  topMessageOffset,
  currentInsight,
  showControlsOverlay,
  isPhone,
  currentGameState,
}) => {
  const SHOW_GAME_STATE_PANEL = false;

  const panelSurfaceSx = {
    background:
      "linear-gradient(160deg, rgba(10, 16, 24, 0.78) 0%, rgba(12, 18, 28, 0.62) 100%)",
    borderRadius: "14px",
    boxShadow: "0 14px 34px rgba(0, 0, 0, 0.34)",
    backdropFilter: "blur(12px) saturate(120%)",
    WebkitBackdropFilter: "blur(12px) saturate(120%)",
  };

  const labelOverlaySx = {
    background:
      "linear-gradient(160deg, rgba(20, 56, 64, 0.62) 0%, rgba(13, 42, 50, 0.54) 100%)",
    borderRadius: "12px",
    boxShadow: "0 10px 26px rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(10px) saturate(120%)",
    WebkitBackdropFilter: "blur(10px) saturate(120%)",
  };

  const mutedLabelSx = {
    display: "block",
    opacity: 0.9,
    letterSpacing: "0.11em",
    textTransform: "uppercase",
    color: "rgba(161, 241, 224, 0.95)",
    fontWeight: 600,
  };

  return (
    <>
      {showEnvironmentLabel && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            bottom: envLabelBottom,
            left: `calc(${playerOffset}px + 50% - ${playerOffset / 2}px)`,
            transform: "translateX(-50%)",
            color: "#fff",
            padding: overlayPadding,
            fontSize: "18px",
            maxWidth: overlayWidth,
            opacity: showEnvironmentLabel ? 1 : 0,
            transition: "opacity 500ms ease",
            zIndex: 20,
            pointerEvents: "none",
            textAlign: "center",
            ...panelSurfaceSx,
          }}
        >
          <Typography variant="caption" sx={{ ...mutedLabelSx, fontSize: isPhone ? "0.94rem" : "1.02rem" }}>
            LOCATION
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: isPhone ? "1.4rem" : "1.8rem", lineHeight: 1.25 }}
          >
            {currentEnvironment?.environmentName}
          </Typography>
        </Box>
      )}

      {instructionsVisible && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            top: topMessageOffset,
            left: `calc(${playerOffset}px + 50% - ${playerOffset / 2}px)`,
            transform: "translateX(-50%)",
            color: "#ecfffb",
            padding: overlayPadding,
            maxWidth: overlayWidth,
            pointerEvents: "none",
            opacity: instructionsVisible ? 1 : 0,
            transition: "opacity 500ms ease",
            zIndex: 20,
            textAlign: "center",
            ...labelOverlaySx,
          }}
        >
          <Typography variant="caption" sx={mutedLabelSx}>
            INSTRUCTION
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontSize: isPhone ? "1rem" : "1.08rem", lineHeight: 1.35 }}
          >
            {currentInsight?.endConditions[0]?.name}
          </Typography>
        </Box>
      )}

      {showControlsOverlay && (
        <Box
          component={animated.div}
          sx={{
            position: "absolute",
            left: "50%",
            bottom: "40px",
            transform: "translateX(-50%)",
            color: "#fff",
            padding: isPhone ? "10px 14px" : "12px 18px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            pointerEvents: "none",
            zIndex: 24,
            textAlign: "center",
            letterSpacing: "0.01em",
            maxWidth: overlayWidth,
            ...panelSurfaceSx,
          }}
        >
          <Typography variant="overline" sx={{ opacity: 0.8, letterSpacing: "0.12em" }}>
            Controls
          </Typography>
          <Typography variant="subtitle1" sx={{ fontSize: isPhone ? "0.98rem" : "1.02rem", fontWeight: 600 }}>
            Scroll to zoom in
          </Typography>
          <Typography variant="subtitle1" sx={{ fontSize: isPhone ? "0.98rem" : "1.02rem", fontWeight: 600 }}>
            Drag to look around
          </Typography>
        </Box>
      )}

      {SHOW_GAME_STATE_PANEL && (
        <Box
          sx={{
            position: "absolute",
            top: `calc(var(--app-header-height, 0px) + 12px)`,
            right: "12px",
            color: "#fff",
            px: "10px",
            py: "6px",
            zIndex: 30,
            pointerEvents: "none",
            textAlign: "right",
            maxWidth: isPhone ? "62vw" : "380px",
            ...panelSurfaceSx,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...mutedLabelSx, letterSpacing: "0.11em" }}
          >
            GAME STATE
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: '"area-extended", "area-normal", sans-serif',
              fontSize: isPhone ? "0.8rem" : "0.9rem",
              lineHeight: 1.2,
              wordBreak: "break-word",
            }}
          >
            {currentGameState}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default StatusOverlays;
